import AreasImportPage from './AreasImportPage';

export default AreasImportPage;
